<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onDestroy, onMount} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let tl = gsap.timeline();

    onMount(() => {
        tl.fromTo(['.Path_14741', '.Path_14743', '.draw *'], {
            drawSVG:"100% 100%",
            transformOrigin: 'center center',
            duration: 1,
        }, {
            drawSVG:"0% 100% ",
            stagger: 0.15,
        }, 0.5);

        tl.from('.Path_14742', {
            scale: 0,
            transformOrigin: 'center center',
            duration: 1,
        }, '<')

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>



<div class="business-container">
    <div class="business-column-right">
        <h1 class="business-header">Four ways thought leadership wins business</h1>
    </div>
    <div class="business-info-box">
        <div class="business-info-diagram diagram-one">
            <svg class="draw" width="393" height="345" fill="none" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
                <path fill="url(#a)" d="M4.56 205.03H80.4v75.84H4.56z" opacity=".85"/>
                <path fill="url(#b)" d="M29.52 145.51h75.84v75.84H29.52z" opacity=".85"/>
                <path fill="url(#c)" d="M48.96 237.43h75.84v75.84H48.96z" opacity=".85"/>
                <path fill="url(#d)" d="M9.84 261.43h75.84v75.84H9.84z" opacity=".85"/>
                <path d="M198.88 100.17c1.83.11 3.65.27 5.45.48m7.37 1.19a90.23 90.23 0 0 1 71.06 74.92" stroke="#fff"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M283.75 190.18a90.15 90.15 0 1 1-90.15-90.16" stroke="#008ED2" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M137 190.18a56.59 56.59 0 1 1 113.19 0 56.59 56.59 0 0 1-113.18 0v0Z" stroke="#008ED2"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M170.77 190.18a22.82 22.82 0 1 1 45.65 0 22.82 22.82 0 0 1-45.65 0v0Zm22.83-90.11v179.74m89.6-89.7H104.14"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="m116.19 132.32-35.22.17a15.56 15.56 0 0 1-9.52-28.1 24.1 24.1 0 0 1 6.6-2.78c.96-.3 1.31-.6 1.47-1.55 1.28-7.82 5.12-14.02 11.94-18.16a24.14 24.14 0 0 1 29.88 3.9l1.77 1.87c5.27-2.3 10.4-2.55 15.15.7 5.33 3.63 7.22 9 6.65 15.24m144.14 97.82a25 25 0 0 1 20.52 7.48c.6.6 1.17 1.23 1.82 1.93 5.44-2.38 10.7-2.63 15.6.72 5.5 3.74 7.44 9.26 6.85 15.7-.13 1.48.16 2.08 1.56 2.63 7.63 2.95 11.3 10.96 9 19.37a14.31 14.31 0 0 1-13.58 10.98c-3.34.25-6.7-.18-9.86-1.28a1.8 1.8 0 0 0-1.63.33c-3.84 5.63-9.44 8.45-15.84 9.85-8.78 1.92-17.29 1.15-25.29-3.18a19.24 19.24 0 0 1-8.18-8.07 2.55 2.55 0 0 0-2.02-.9 14.9 14.9 0 0 1-5.16-.64"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <defs>
                    <pattern id="a" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#e" transform="scale(.01299)"/>
                    </pattern>
                    <pattern id="b" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#f" transform="scale(.01299)"/>
                    </pattern>
                    <pattern id="c" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#g" transform="scale(.01299)"/>
                    </pattern>
                    <pattern id="d" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#h" transform="scale(.01299)"/>
                    </pattern>
                    <image id="e" width="77" height="77"
                           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABNCAYAAADjCemwAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATaADAAQAAAABAAAATQAAAACPtwcpAAABy0lEQVR4Ae3aS0rDUABG4XtDa+oD1Nap7qAuw4m6VHEuuABnCu5AJ4IWq32kL+PNEnKgcpFTkEzy0+bzJKPEuq6Dn3YCRbvTPbsREA10IJpoQABMLE00IAAmliYaEAATSxMNCICJpYkGBMDE0kQDAmBiaaIBATCxNNGAAJhYmmhAAEwsTTQgACaWJhoQABNLEw0IgImliQYEwMTSRAMCYGJpogEBMLG0/4Q2WYWi+QPXtPVJZ+vf0PILqk0ont6r/ny9PEvT1WFZvgz75bhThGzec425vXP78FadzFbVdV3/XMUYpyHEm8Hu3v35YGfS0n9rp2dVWnM7VuvlaQK7TFd8kf6hi3T8HC9WjyHkg5bbMyPdgnGRCvtKWFV68bxqjiHGTTpm88mqtINuqI97vdeP+fQ2CX3HGBYhFndHZXeUjVj6Idk9037qEJ9Hy/10Sw6awhqwYb87Ey0nAfBbcnumgUv4+4lowFw00YAAmFiaaEAATCxNNCAAJpYmGhAAE0sTDQiAiaWJBgTAxNJEAwJgYmmiAQEwsTTRgACYWJpoQABMLE00IAAmliYaEAATSxMNCICJpYkGBMDE0kQDAmBiaaIBATCxNID2C6SBWLZWYcgYAAAAAElFTkSuQmCC"/>
                    <image id="f" width="77" height="77"
                           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABNCAYAAADjCemwAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATaADAAQAAAABAAAATQAAAACPtwcpAAAB20lEQVR4Ae3aPUoDURhG4fuNf0ENqAiCgtmAqxC34DIFW0tLWwux18YfGFGTmEmc680Ggh4wTHGEYJF5meTJmYFAIuec/PubQPW3wz16LiAa6EA00YAAmFiaaEAATCxNNCAAJpYmGhAAE0sTDQiAiaWJBgTAxNJEAwJgYmmiAQEwsTTRgACYWJpoQABMLE00IAAmliYaEAATSxMNCICJpYkGBMDE0kQDAmBiaaIBATBZBZt/n0y+UzRtikgpb6+lzv2+tXNoz+O8el+PD77b6WEV1XC313s82Vv7qKI7eNGlHyrPC7t5Gh3O2uY85fY0pXipIi72N7euC9zw3xP/5Qk6Vdq0XJJtnh3ltj0rr/80In+Ua7N+m0xvUxJt0WfalJvZZzlgXB7lf7wXuNmiwbKf61Rp5abfrq+sP3zlfFkuz5eIeC2Pq0G/Vy8bZtH5OnVPm7/Q0SxVd3XTH02bnYiVyaC/UR9vV5NFb2LZz3UObdkA5Hx+IwBqookGBMDE0kQDAmBiaaIBATCxNNGAAJhYmmhAAEwsTTQgACaWJhoQABNLEw0IgImliQYEwMTSRAMCYGJpogEBMLE00YAAmFiaaEAATCxNNCAAJpYmGhAAE0sTDQiAiaUBtB8h3lvcDqrg+gAAAABJRU5ErkJggg=="/>
                    <image id="g" width="77" height="77"
                           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABNCAYAAADjCemwAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATaADAAQAAAABAAAATQAAAACPtwcpAAAB0klEQVR4Ae3aPU4CURhG4e8O/hD/Eg2JjUYX4DIsjJUbNbG3srHXwg1oYaFggjrAINfrEjgJ5haHhoTMm2EeDlNNyjmHr+UEmuUO9+g/AdFAB6KJBgTAxNJEAwJgYmmiAQEwsTTRgACYWJpoQABMLE00IAAmliYaEAATSxMNCICJpYkGBMDE0kQDAmBiaaIBATCxNNGAAJhYmmhAAEwsTTQgACaWJhoQABNLEw0IgEm1pY27aD67SOCaVj5ZW/kZljzB1zx6D2/tYPYzO0rRtPv9/svZwfq4SVHNw8GptgeV71/bw+l8chU5X+RIwyal68HW9l2B+1rSf2WHV1Va+Ts2pbDj8kNelis+j8ifJa/Rx7R7jKgHrcJ7WpoXsLY8qT8t798RaVyK+/usmldVpe2sx2Kjt/E8yfkmxeK9KA3LA+i3J7ubo2rEyhep7p72PY/maTTbbbtufxExO93rD092ehPRahIA36XCexq4in+eiAbARRMNCICJpYkGBMDE0kQDAmBiaaIBATCxNNGAAJhYmmhAAEwsTTQgACaWJhoQABNLEw0IgImliQYEwMTSRAMCYGJpogEBMLE00YAAmFiaaEAATCxNNCAAJpYmGhAAk19b4Vm94bHYwQAAAABJRU5ErkJggg=="/>
                    <image id="h" width="77" height="77"
                           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABNCAYAAADjCemwAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATaADAAQAAAABAAAATQAAAACPtwcpAAABx0lEQVR4Ae3aPU4CQQBH8ZmNi/hVALbeQL2GhfGsnMBYW2o8go2JYhTQ5XOd0RPsSzBTPBJCs//A/ni7NMS2bYOPbgJVt8M9OguIBjoQTTQgACaWJhoQABNLEw0IgImliQYEwMTSRAMCYGJpogEBMLE00YAAmFiaaEAATCxNNCAAJpYmGhAAE0sTDQiAiaWJBgTAxNJEAwJgYmmiAQEwsTTRgACYWJpoQABMii1ttgpVekZwTjuf7O38HTq+QbMJ1cNrM2zWy7MQ4mLQ7z+fD+tpFUMxfw6Opf1R+f6lOf1aNTdtu72OMX4muPHo4PDuctSbdfTf2eFFlZYvyVxYBktnfJW+0Ca9Tj8Wq8cQykEr7Z6WLsG4+CssZLDl7zPGTXot5lFUacd1aPM97O17Pk5C+XJcJ8DbwX79XoxY+iDF3dO2bYhPk+VRuiRHMd38T3r15GLYm/tDUFI24LOUdk8Dp/D/E9GAuWiiAQEwsTTRgACYWJpoQABMLE00IAAmliYaEAATSxMNCICJpYkGBMDE0kQDAmBiaaIBATCxNNGAAJhYmmhAAEwsTTQgACaWJhoQABNLEw0IgImliQYEwMTSRAMCYPIDHhpXx3q3WLkAAAAASUVORK5CYII="/>
                </defs>
            </svg>
        </div>
        <div class="business-info-text">
            <div class="business-info-header">1</div>
            <p class="business-info-subheader">It gets you on their radar</p>
            <div class="business-info-description"> Thought leadership plays a vital role in ensuring your brand is
                considered for big transformation projects.
            </div>
            <div class="business-info-statistic">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="195.569" height="201.63" viewBox="0 0 195.569 201.63">
                    <defs>
                        <clipPath id="clip-path">
                            <rect id="Rectangle_750" data-name="Rectangle 750" width="195.569" height="201.63" fill="none"/>
                        </clipPath>
                    </defs>
                    <text id="_87_" data-name="87%" transform="translate(29 53)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric" font-weight="700"><tspan x="2.962" y="81">87%</tspan></text>
                    <g id="Group_1461" data-name="Group 1461" transform="translate(-676 -553)">
                        <g id="Group_1462" data-name="Group 1462" transform="translate(676 553)">
                            <g id="Group_1461-2" data-name="Group 1461" clip-path="url(#clip-path)">
                                <path class="Path_14741" data-name="Path 14741" d="M97.785,7.061A96.785,96.785,0,1,1,1,103.846C1,80.327,7.768,61.215,22.569,42.937L26.8,38.312" fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path class="Path_14742" data-name="Path 14742" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4" fill="#fff"/>
                                <path class="Path_14743" data-name="Path 14743" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,92.541,6.6Z" fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
                            </g>
                        </g>
                    </g>
                </svg>

                <p>of business leaders say that thought leadership helps them to build their “watch list” for future
                    partners.</p>
            </div>
        </div>
    </div>
    <div class="business-info-box">
        <div class="business-info-diagram diagram-two">
            <svg class="draw" width="281" height="211" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M202.78 69.1v61.67H44.87V46.04h116.51" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="m179.53 101.21-31.89-37.64a2.18 2.18 0 0 0-2.7-.48c-.3.17-.54.4-.72.67L120 100l-16.2-16.2a2.14 2.14 0 0 0-3.04 0l-32.54 32.54m20.32-57.27a8.87 8.87 0 1 1 0 17.73 8.87 8.87 0 0 1 0-17.73v0Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="m164.8 49.07-9.44-9.44 9.43-9.43a71.4 71.4 0 0 1 100.98 0l9.44 9.43-9.44 9.44a71.4 71.4 0 0 1-100.97 0v0Z"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M192.85 39.63a22.44 22.44 0 1 1 44.87 0 22.44 22.44 0 0 1-44.87 0v0Z" stroke="#fff"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M203.95 39.63a11.33 11.33 0 1 1 22.67 0 11.33 11.33 0 0 1-22.67 0v0ZM150.79 25.3l22.29-12.7a83.92 83.92 0 0 1 80.76-1.3l25.32 13.38"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M60.1 165.9a12.61 12.61 0 0 0 10.57 6.4l42.35 1.82a4.1 4.1 0 0 0 1.6-.23m39.71 35.39c-1.87-14.03-21.98-10.8-31.65-9.77-12.81 1.39-25.4 4.18-38.36 4.18-23.22 0-49.48-20.25-66.22-34.53-4.69-4-27.53-25.45-11.44-29.05 2.5-.56 5.06.42 7.3 1.64 5.65 3.07 10.27 7.67 15.4 11.52 8.55 6.43 19.9 12.08 30.7 12.74-4.4-7.79 1.55-16.42 10.91-16.42l22.19.68c5.43 0 9.53-1.3 14.72-2.8a67.23 67.23 0 0 1 19.93-3.14c15.6 0 30.44 9.29 35.65 24.44l-9.13 40.5Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M169.17 188.25h1.72a77.75 77.75 0 0 0 77.73-77.73V73.28" stroke="#fff" stroke-width="3"
                      stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="business-info-text">
            <div class="business-info-header">2</div>
            <p class="business-info-subheader">It articulates your vision and values</p>
            <div class="business-info-description">Buyers will use your thought business to build a picture of your
                vision and values.
            </div>
            <div class="business-info-statistic">
                <svg class="draw" width="218" height="217" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m36.84 143.78 35.83 35.84m36.81-35.84-35.84 35.84 35.84 35.84 35.84-35.84-35.84-35.84Zm35.12 35.84 35.83-35.84M72.67 36.84 36.84 72.67M109.48 1 73.64 36.84l35.84 35.83 35.84-35.83L109.48 1Z"
                          stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M180.43 1 144.6 36.84l35.84 35.83 35.84-35.83L180.43 1ZM36.84 71.95 1 107.8l35.84 35.84 35.83-35.84-35.83-35.84Zm72.64 0L73.64 107.8l35.84 35.84 35.84-35.84-35.84-35.84Z"
                          stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M180.43 71.95 144.6 107.8l35.84 35.84 35.84-35.84-35.84-35.84Z" stroke="#008ED2"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M104.42 182.12a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0ZM68.95 145.8a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Zm35.47-36.32a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0ZM139.9 74a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Zm1.69 70.96a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0ZM68.95 73.5a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Zm106.09 35.98a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Zm-145.79 0a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Zm75.17-70.95a5.4 5.4 0 1 1 10.8 0 5.4 5.4 0 0 1-10.8 0Z"
                          fill="#fff"/>
                </svg>
                <p>9 out of 10 business leaders say that thought leadership plays an important role in their
                    understanding of a firm’s vision and values</p>
            </div>
        </div>
    </div>
    <div class="business-info-box">
        <div class="business-info-diagram diagram-three">
            <svg class="draw" width="215" height="218" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.36 91.13c-12.1.61-21.66-7.74-24.85-17.1-3.77-11.04-.38-23 9.03-29.59 3.19-2.23 7.18-3.43 10.96-4.62 1.6-.51 2.18-1 2.44-2.58 2.13-13 8.51-23.3 19.85-30.18a40.12 40.12 0 0 1 49.66 6.49c.95.98 1.88 1.98 2.94 3.11 8.77-3.83 17.27-4.24 25.18 1.16 8.86 6.03 12 14.94 11.05 25.33-.22 2.4.26 3.37 2.52 4.25 12.31 4.77 18.23 17.68 14.51 31.25"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M58.76 216.84a19.32 19.32 0 0 0-16.2-19.06 19.83 19.83 0 0 1-24.1-.12 19.32 19.32 0 0 0-17.03 19.18m29.21-19.69a17.9 17.9 0 1 0 0-35.8 17.9 17.9 0 0 0 0 35.8Zm79.72-3.48a19.32 19.32 0 0 0-16.19-19.06 19.83 19.83 0 0 1-24.1-.12 19.32 19.32 0 0 0-17.03 19.18m29.2-19.69a17.9 17.9 0 1 0 0-35.8 17.9 17.9 0 0 0 0 35.8Zm79.72 42.86a19.32 19.32 0 0 0-16.19-19.06 19.83 19.83 0 0 1-24.1-.12 19.32 19.32 0 0 0-17.03 19.18m29.2-19.69a17.9 17.9 0 1 0 0-35.8 17.9 17.9 0 0 0 0 35.8Zm79.72-3.48a19.32 19.32 0 0 0-16.18-19.06 19.83 19.83 0 0 1-24.1-.12 19.32 19.32 0 0 0-17.04 19.18m29.2-19.69a17.9 17.9 0 1 0 0-35.8 17.9 17.9 0 0 0 0 35.8Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M47.57 118.43H11.74v35.83h35.83v-35.83Zm105.98 35.83H117.7l35.84-35.84v35.84Zm-70.24-23.11a17.92 17.92 0 1 1 0-35.83 17.92 17.92 0 0 1 0 35.83v0Zm106.28-42.91 3.45-2.32a3.87 3.87 0 0 1 5.95 2.47l.8 4.08a3.87 3.87 0 0 0 3.05 3.05l4.08.8a3.87 3.87 0 0 1 2.46 5.94l-2.32 3.45a3.87 3.87 0 0 0 0 4.32l2.32 3.45a3.88 3.88 0 0 1-2.46 5.95l-4.08.8a3.87 3.87 0 0 0-3.05 3.05l-.8 4.08a3.87 3.87 0 0 1-5.95 2.46l-3.45-2.32a3.87 3.87 0 0 0-4.32 0l-3.45 2.32a3.88 3.88 0 0 1-5.95-2.46l-.8-4.08a3.87 3.87 0 0 0-3.04-3.05l-4.09-.8a3.87 3.87 0 0 1-2.46-5.95l2.32-3.45a3.87 3.87 0 0 0 0-4.31l-2.32-3.46a3.88 3.88 0 0 1 2.46-5.95l4.09-.8a3.86 3.86 0 0 0 3.04-3.04l.8-4.08a3.86 3.86 0 0 1 5.95-2.47l3.45 2.32a3.86 3.86 0 0 0 4.32 0v0Z"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="business-info-text">
            <div class="business-info-header">3</div>
            <p class="business-info-subheader">It helps you to influence a multidisciplinary buyer group</p>
            <div class="business-info-description">With 9+ executives on the average buying team, you need to be able to
                engage at multiple levels. The right thought leadership strategy will resonate with C&#8209;suite
                decision-makers in your target audience.
            </div>
        </div>
    </div>
    <div class="business-info-box">
        <div class="business-info-diagram diagram-four">
            <svg class="draw" width="184" height="229" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 91.35v117.97h166.08v-82.5" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M81.74 1.45h85.34v125.37M1 91.35V1.45h80.74" stroke="#008ED2" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="m69.5 111.2 13.07 13.06 30.94-30.94" stroke="#fff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M113.71 140.99a9.03 9.03 0 1 1-9.03-9.19 9.1 9.1 0 0 1 9.03 9.19Zm-14.63 27.54H115a5.2 5.2 0 0 0 5.16-5.24v-2.63a15.8 15.8 0 0 0-6.23-12.6m-41.5-7.07a9.03 9.03 0 1 1-9.03-9.19 9.1 9.1 0 0 1 9.03 9.19"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M54.15 148.06a15.79 15.79 0 0 0-6.23 12.6v2.63a5.2 5.2 0 0 0 5.16 5.25h16.4" stroke="#008ED2"
                      stroke-width="2.02" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M93.07 154.1a9.03 9.03 0 1 1-9.03-9.18 9.1 9.1 0 0 1 9.03 9.19" stroke="#fff" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M74.8 161.18a15.8 15.8 0 0 0-6.24 12.6v2.63a5.2 5.2 0 0 0 5.16 5.25h20.64a5.2 5.2 0 0 0 5.16-5.25v-2.63a15.8 15.8 0 0 0-6.24-12.6"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M85.64 199.28a63.5 63.5 0 1 0 0-127.01 63.5 63.5 0 0 0 0 127Z" stroke="#fff" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M49.16 102.01a49.57 49.57 0 0 1 36.48-15.94" stroke="#008ED2" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="m133.86 177.68 49.12 49.9" stroke="#fff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M45.08 21.38h88.73" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M33.27 21.38a2.49 2.49 0 1 1 4.97 0 2.49 2.49 0 0 1-4.97 0Z" fill="#fff"/>
                <path d="M45.08 39.7h88.73" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M33.27 39.7a2.49 2.49 0 1 1 4.97 0 2.49 2.49 0 0 1-4.97 0Z" fill="#fff"/>
                <path d="M45.08 58.04h88.73" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M33.27 58.04a2.49 2.49 0 1 1 4.97 0 2.49 2.49 0 0 1-4.97 0" fill="#fff"/>
            </svg>
        </div>
        <div class="business-info-text">
            <div class="business-info-header">4</div>
            <p class="business-info-subheader">It gets you on the shortlist</p>
            <div class="business-info-description">Companies increasingly need to show they can think innovatively to
                make the shortlist for a major partnership — even before meeting the client.
            </div>
            <div class="business-info-statistic">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="195.569" height="201.63" viewBox="0 0 195.569 201.63">
                    <defs>
                        <clipPath id="clip-path">
                            <rect id="Rectangle_750" data-name="Rectangle 750" width="195.569" height="201.63" fill="none"/>
                        </clipPath>
                    </defs>
                    <text id="_87_" data-name="87%" transform="translate(29 53)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric" font-weight="700"><tspan x="2.962" y="81">87%</tspan></text>
                    <g id="Group_1461" data-name="Group 1461" transform="translate(-676 -553)">
                        <g id="Group_1462" data-name="Group 1462" transform="translate(676 553)">
                            <g id="Group_1461-2" data-name="Group 1461" clip-path="url(#clip-path)">
                                <path class="Path_14741" data-name="Path 14741" d="M97.785,7.061A96.785,96.785,0,1,1,1,103.846C1,80.327,7.768,61.215,22.569,42.937L26.8,38.312" fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                <path class="Path_14742" data-name="Path 14742" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4" fill="#fff"/>
                                <path class="Path_14743" data-name="Path 14743" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,92.541,6.6Z" fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
                            </g>
                        </g>
                    </g>
                </svg>


                <p>of business leaders say that thought leadership plays an important role in their shortlisting
                    decisions.</p>
            </div>
        </div>
    </div>
</div>

<style>
    .business-container {
        padding-right: 40px;
    }

    .business-info-box {
        margin-top: 100px;
        display: flex;
        flex-direction: column;
    }

    .business-info-diagram {
        display: flex;
        justify-content: center;
    }

    .business-info-text {
        display: flex;
        flex-direction: column;
        color: white;
    }

    .business-header {
        color: #f5d2b5;
        font-weight: 500;
        font-size: 44px;
        line-height: 44px;
        margin-bottom: 0;
    }

    .business-introduction {
        font-size: 28px;
        color: white;
    }

    .business-info-header {
        color: #00a0dd;
        font-weight: 700;
        font-size: 58px;
        margin-bottom: 0;
        margin-top: 15px;
    }

    .business-info-description {
        font-size: 26px;
        margin-top: 0;
        color: white;
    }

    .business-info-subheader {
        font-weight: 700;
        font-size: 27px;
        line-height: 33px;
        margin: 6px;
    }

    .business-info-statistic {
        color: white;
        margin-top: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .business-info-statistic p {
        margin-top: 30px;
        font-size: 23px;
    }

    @media (min-width: 900px) {
        .business-container {
            display: flex;
            flex-direction: column;
            align-items: end;
        }

        .business-info-box {
            flex-direction: row;
            margin-top: 50px;
        }

        .business-info-header {
            margin-top: 0;
        }

        .business-info-statistic {
            flex-direction: row;
            align-items: center;
            display: flex;
            margin-top: 0;
            justify-content: space-between;
        }

        .business-info-statistic p {
            font-size: 16px;
            margin: 0;
            max-width: 188px;
        }

        .business-column-right {
            max-width: 445px;
        }

        .business-info-diagram {
            min-width: 215px;
        }

        .business-info-diagram svg {
            transform: scale(0.7);
        }

        .business-info-text {
            max-width: 434px;
        }

        .business-info-statistic svg {
            transform: scale(0.7);
        }

        .business-header {
            margin-left: 16px;
        }

        .diagram-one {
            margin-top: -80px;
        }

        .diagram-two {
            margin-right: 55px;
        }

        .diagram-three, .diagram-four {
            margin-right: 85px;
        }
    }

</style>